import * as React from 'react';
import { EditComponent, CreateComponent, CustomComponentProps } from 'src/components/common/Component';

export function CategoryEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function CategoryCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"category"} children={children} />
    );
}
